<template>
  <ComplianceUpdatedByCell
    :data-test="`recruiter-compliance-updated-by-${index}`"
    :reviewer-name="reviewerName"
    :reviewed-at="reviewedAt"
  />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { FragmentType, graphql, useFragment } from '@/gql'
import ComplianceUpdatedByCell from '@/components/GraphqlDataTable/columns/Compliance/ComplianceUpdatedByCell.vue'
import {
  complianceDate,
  complianceReviewerName,
  VerifiedComplianceDateKey,
} from '@/components/GraphqlDataTable/columns/Compliance/verifiedComplianceData'

const RecruiterComplianceUpdatedByColumn = graphql(`
  fragment RecruiterComplianceUpdatedByColumn on CompanyRecruiter {
    id
    verifiedCompliance: compliances(names: [VERIFIED_RECRUITER_COMPLIANCE]) {
      name
      data {
        ...VerifiedComplianceUser
        ...VerifiedComplianceDate
      }
    }
  }
`)

const props = defineProps<{
  row: FragmentType<typeof RecruiterComplianceUpdatedByColumn>
  index: number
}>()

const column = computed(() => useFragment(RecruiterComplianceUpdatedByColumn, props.row))
const data = computed(() => column.value.verifiedCompliance?.[0]?.data)
const reviewerName = computed(() => complianceReviewerName(data.value))
const reviewedAt = computed(() => complianceDate(data.value, VerifiedComplianceDateKey.ReviewedAt))
</script>
